







































import { mapGetters } from 'vuex';

export default {
    name: 'FileUploadInput',

    setup() {
        const file = ref(null);
        const fileName = ref(null);
        return {
            file,
            fileName,
        };
    },

    computed: {
        ...mapGetters({
            theme: 'getTheme',
        }),
    },

    props: {
        text: {
            required: false,
            type: String,
        },
        value: {
            required: false,
        },
        error: {
            default: '',
            required: false,
            type: String,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
        type: {
            required: false,
            type: String,
        },
        wrapped: {
            default: true,
            required: false,
            type: Boolean,
        },
    },

    mounted() {
        if (typeof this.value === 'string') {
            this.fileName = this.value;
        }
    },

    watch: {
        value() {
            if (typeof this.value === 'string') {
                this.fileName = this.value;
            }

            if (!this.value) {
                this.fileName = null;
                this.file = null;
            }
        },
    },

    methods: {
        //Clear event target so user can select same image after delete/remove
        inputClick(event) {
            event.target.value = '';
        },
        onChange() {
            if (['pdf', 'docx', 'doc'].includes(this.$refs.fileInput.files[0].type.split('/')[1])) {
                this.file = this.$refs.fileInput.files[0];
                this.fileName = this.$refs.fileInput.files[0].name;
            } else {
                this.$toast.show({
                    type: 'danger',
                    message: 'File can only be pdf, docx or word.',
                });
            }
        },
        updateValue() {
            if (this.$refs.fileInput.files.length !== 0) {
                this.file = this.$refs.fileInput.files[0];
                this.fileName = this.$refs.fileInput.files[0].name;

                if (!this.wrapped) {
                    this.$emit('input', this.file);
                    return;
                }

                const fd = new FormData();
                fd.append('document', this.file);
                fd.append('name', this.fileName);
                if (this.type) {
                    fd.append('document_type', this.type);
                }

                this.$emit('input', fd);
            }
        },

        remove() {
            this.file = null;
            this.fileName = null;
            this.$emit('input', null);
        },

        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains('border-primaryy')) {
                event.currentTarget.classList.remove('border-border-form');
                event.currentTarget.classList.add('border-primary');
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.add('border-border-form');
            event.currentTarget.classList.remove('border-primary');
        },
        drop(event) {
            event.preventDefault();
            this.$refs.fileInput.files = event.dataTransfer.files;
            this.onChange();
            // Clean up
            event.currentTarget.classList.add('border-border-form');
            event.currentTarget.classList.remove('border-primary');
        },
    },
};
